import { IntegracaoWhatsappInicial, type IntegracaoWhatsappModel } from "../models/integracaoWhatsappModel"
import {
    IntegracaoWhatsappActionsTypes,
    type IntegracaoWhatsappActions,
} from "./integracaoWhatsappActions"

const { CARREGAR, CARREGAR_TEMPLATES, ATUALIZAR_WABAID, ATUALIZAR_ATIVO, CONFIRMAR_SAVE, REMOVER_TEMPLATE } =
    IntegracaoWhatsappActionsTypes

export function integracaoWhatsappReducer(
    state: IntegracaoWhatsappModel,
    action: IntegracaoWhatsappActions
): IntegracaoWhatsappModel {
    switch (action.type) {
        case CARREGAR: {
            const d = action.payload
            return {
                ...state,
                integracaoId: d.id,
                wabaid: d.wabaid ?? "",
                conta: d.conta ?? "",
                telefone: d.telefone ?? "",
                ativo: d.ativo,
                qualityRating: d.qualityRating ?? "",
                verificationStatus: d.verificationStatus ?? "",
                phoneNumber: d.phoneNumber ?? "",
                verifiedName: d.verifiedName ?? "",
                webhook: d.webhook ?? "",
            }
        }

        case CARREGAR_TEMPLATES: {
            return {
                ...state,
                templates: action.payload.map(t => ({
                    id: t.id,
                    name: t.name,
                    parameter_format: t.parameter_format,
                    status: t.status,
                    category: t.category,
                    language: t.language,
                })),
            }
        }

        case ATUALIZAR_WABAID:
            return { ...state, wabaid: action.payload }

        case ATUALIZAR_ATIVO:
            return { ...state, ativo: action.payload }

        case CONFIRMAR_SAVE: {
            const d = action.payload
            return {
                ...state,
                integracaoId: d.id,
                wabaid: d.wabaid ?? "",
                conta: d.conta ?? "",
                telefone: d.telefone ?? "",
                ativo: d.ativo,
            }
        }

        case REMOVER_TEMPLATE:
            return {
                ...state,
                templates: state.templates.filter(t => t.name !== action.payload),
            }

        default:
            return state
    }
}

export { IntegracaoWhatsappInicial }
